'use strict';

import * as Props from '../Props';

const angular = require('angular');

let contolSty = angular.copy(Props.controlStyleObject);
delete contolSty['style-group'].members.alignment;


const DropdownProperties = {
    Basic: {
        'ControlType': 'Dropdown',
        'Label': {
            name: 'label',
            selectedValue: 'Dropdown',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
            disable: false
        },
        'Field Name': Props.getFieldName('Dropdown'),
        'Data Field Name': Props.getDataFieldName('Dropdown'),
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Value': {
            selectedValue: [],
            hidden: true
        },
        'Multi-Select': {
            name: 'multi.select',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'resetDefault',
            disable:false
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
        'FilterValue': {
            isFilterValue: 1,
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'App Status':{
            name: 'app.status',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'enableAppStatusSync',
            disable:false
        },
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    },
    "Data Source": {
        'Source': {
            name: 'source',
            type: 'radio',
            selectedValue: '3',
            list: [
                /*{
                    name:'Adoddle API',
                    value: '1'
                },*/
                /*{
                    name:'External',
                    value: '2'
                },*/
                {
                    name: 'Static-Data',
                    value: '3'
                },
                {
                    name: 'System-Data',
                    value: '4',
                    tooltip: 'System attributes are available for fetching the system level data e.g. Project Name etc.'
                },
                {
                    name: 'Link-to-Custom-Attribute',
                    value: '5'
                }
            ]
        },
        Url: {
            name: 'Url',
            selectedValue: '',
            hidden: true
        },
        fixedFieldUrl: {
            name: 'Url',
            singleValue: false,
            selectedValue: '',
            hidden: true
        },
        customAttr: {
            name: 'customAttr',
            selectedValue: '',
            hierarchyData: [],
            hierarchyApplied: false,
            displayVal: '1',
            hidden: true
        },
        'Parameters': {
            type: 'table',
            headers: ['key', 'value'],
            list: [
                {
                    key: {
                        name: '',
                        type: 'text',
                        inputWidth: "width:100px;"
                    },
                    value: {
                        name: '',
                        type: 'text',
                        inputWidth: "width:100px;"
                    }
                }
            ],
            hidden: true
        },
        'table': {
            type: 'table',
            headers: ['Label', 'Value', 'Default'],
            default: 'datasource',
            list: [
                {
                    id: 1,
                    Label: {
                        name: 'Option 1',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: 'option1',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: ""
                    },
                    showUpdateOptions: true,
                    relation: {}
                },
                {
                    id: 2,
                    Label: {
                        name: 'Option 2',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: 'option2',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: ""
                    },
                    showUpdateOptions: true,
                    relation: {}
                }
            ],
            hidden: true
        },
        'Name': {
            selectedValue: 'datasource',
            hidden: true
        }
    }
};

export default DropdownProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Dropdown.ts